export default __webpack_public_path__ + "static/logo_full2-5b9b824a28ec8d0223b1e653b4f2cb8e.png";